import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
} from "@mui/material";
import icon1 from "./img/cardIcon1.svg";
import icon2 from "./img/cardIcon2.svg";
import icon3 from "./img/cardIcon3.svg";
import icon4 from "./img/cardIcon4.svg";
import icon5 from "./img/cardIcon5.svg";
import icon6 from "./img/cardIcon6.svg";
import icon7 from "./img/cardIcon7.svg";
import icon8 from "./img/cardIcon8.svg";

const cardData = [
  {
    icon: <img src={icon1} alt="icon1" width="32" height="32" />,
    title: (
      <>
        Multiple Human Live <span style={{ color: "#00C851" }}>Chat</span>
      </>
    ),
    desc: "Enable Multiple Human-Agent Live Chat Support on the same Whatsapp number.",
  },
  {
    icon: <img src={icon2} alt="icon2" width="32" height="32" />,
    title: (
      <>
        Chatbot Flow <span style={{ color: "#00C851" }}>Builder</span>
      </>
    ),
    desc: "Build multiple WhatsApp Chatbots easily, thanks to a drag-and-drop interface that requires zero coding expertise.",
  },
  {
    icon: <img src={icon3} alt="icon3" width="32" height="32" />,
    title: (
      <>
        Retarget Users on <span style={{ color: "#00C851" }}>WhatsApp</span>
      </>
    ),
    desc: "VertexSuite's WhatsApp Retarget feature allows you to segregate your audience and Re-Broadcast for higher conversions.",
  },
];

const extraCardData = [
  {
    icon: <img src={icon4} alt="icon4" width="32" height="32" />,
    title: (
      <>
        WhatsApp <span style={{ color: "#00C851" }}>Scheduler</span>
      </>
    ),
    desc: "Schedule Broadcasts up to 2 months ahead of time across varying timezones.",
  },
  {
    icon: <img src={icon5} alt="icon5" width="32" height="32" />,
    title: (
      <>
        Import, Broadcast & <span style={{ color: "#00C851" }}>Track</span>
      </>
    ),
    desc: "Track users clicking on your message's CTA buttons with this Pro Feature.",
  },
  {
    icon: <img src={icon6} alt="icon6" width="32" height="32" />,
    title: (
      <>
        Ads that <span style={{ color: "#00C851" }}>Click </span>to WhatsApp
      </>
    ),
    desc: "Drive 5x More Leads with Ads that Click to WhatsApp.",
  },
];

const moreCardData = [
  {
    icon: <img src={icon7} alt="icon7" width="32" height="32" />,
    title: (
      <>
        WhatsApp <span style={{ color: "#00C851" }}>Webviews</span>
      </>
    ),
    desc: "Load web pages directly within WhatsApp. No more losing customers to external browsers.",
  },
  {
    icon: <img src={icon8} alt="icon8" width="32" height="32" />,
    title: (
      <>
        WhatsApp <span style={{ color: "#00C851" }}>Forms</span>
      </>
    ),
    desc: "Create and send forms with this native integration. Capture leads, book appointments, collect feedback and more.",
  },
];

const cardColors = [
  "rgba(227, 242, 253, 0.5)", // Light Blue
  "rgba(232, 245, 233, 0.5)", // Light Green
  "rgba(252, 228, 236, 0.5)", // Light Pink
  "rgba(255, 243, 224, 0.5)", // Light Orange
  "rgba(237, 231, 246, 0.5)", // Light Purple
  "rgba(224, 247, 250, 0.5)", // Light Cyan
  "rgba(243, 229, 245, 0.5)", // Light Magenta
  "rgba(255, 253, 231, 0.5)", // Light Yellow
];

const CardMenuSection = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        backgroundImage: `url('bg2.svg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
      }}
    >
      <Box
        sx={{
          px: { xs: 2, sm: 4, md: 10 },
          py: { xs: 4, sm: 6, md: 8 },
          width: { xl: "74%", lg: "79%", md: "90%", sm: "90%" },
        }}
      >
        <Typography
          variant="h3"
          fontWeight="bold"
          sx={{
            fontSize: { xs: "2rem", md: "3.2rem" },
            mb: 2,
            textAlign: 'center',
          }}
        >
          Everything You Need for{" "}
          <span style={{ color: "#00C851" }}>Whatsapp</span> Engagement
        </Typography>
        <Typography
          variant="body1"
          color="text.secondary"
          sx={{
            mb: 5,
            fontSize: { xs: "1.3rem", md: "1.4rem" },
            textAlign: 'center',
          }}
        >
          Vertex Suite Platform covers all aspects of Marketing, CRM & Customer
          Support in one place.
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {[...cardData, ...extraCardData, ...moreCardData].map(
            (card, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    p: 2,
                    height: "100%",
                    borderRadius: 2,
                    cursor: "pointer",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    backgroundColor: cardColors[index % cardColors.length], // Assign color based on index
                    backdropFilter: 'blur(5px)',
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: 6,
                    },
                  }}
                >
                  <CardContent sx={{ textAlign: "left" }}>
                    <Box sx={{ mb: 2 }}>{card.icon}</Box>
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        mb: 1,
                        fontSize: { xs: "1.2rem", md: "1.4rem" },
                      }}
                    >
                      {card.title}
                    </Typography>
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      sx={{ mb: 2, fontSize: { xs: "1rem", md: "1.1rem" } }}
                    >
                      {card.desc}
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#00C851",
                        color: "#fff",
                        textTransform: "none",
                        fontWeight: "bold",
                        "&:hover": { backgroundColor: "#00b34d" },
                      }}
                    >
                      Learn More
                    </Button>
                  </CardContent>
                </Card>
              </Grid>
            )
          )}
        </Grid>
      </Box>
    </Box>
  );
};

export default CardMenuSection;
